import {
  base_colorContentBorder,
  base_colorRaisedSurface,
} from 'ext-ui/style/colors'
import { flyout_outerBlockVSpacing, spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.TransactionFlyout .BaseFlyout-Content {
    .BaseFlyout-CloseBar {
      background-color: ${base_colorRaisedSurface};
    }

    .BaseFlyout-Body {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      align-self: stretch;
      padding-top: ${spacing(7)};
      padding-bottom: ${spacing(10)};
      background-color: ${base_colorRaisedSurface};

      & > * {
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
      }

      & > *:not(:last-child) {
        ::after {
          content: '';
          margin: ${flyout_outerBlockVSpacing} 0;
          left: 0;
          right: 0;
          height: 1px;
          background: ${base_colorContentBorder};
        }
      }
    }

    .policyAgent > div {
      padding-left: 0;
      padding-right: 0;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0;
    }

    &.secondaryFlyout {
      .BaseFlyout-Body {
        overflow: hidden;
      }
    }
  }
`
